// src/pages/VehicleLocationsBarChart.jsx
import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const VehicleLocationsBarChart = ({
  dayData = [],
  nightData = [],
  groupLevel,
  onItemSelect,
  colors,
}) => {
  // Combinar datos (día + noche)
  const dict = {};
  dayData.forEach((item) => {
    const key = item.level || "SIN_DIA";
    if (!dict[key]) dict[key] = { day: 0, night: 0 };
    dict[key].day += Number(item.total_vehiculos || 0);
  });
  nightData.forEach((item) => {
    const key = item.level || "SIN_NOCHE";
    if (!dict[key]) dict[key] = { day: 0, night: 0 };
    dict[key].night += Number(item.total_vehiculos || 0);
  });

  // Convertir a array y ordenar
  const combinedArray = Object.keys(dict)
    .map((key) => ({
      level: key,
      day: dict[key].day,
      night: dict[key].night,
      total: dict[key].day + dict[key].night,
    }))
    .sort((a, b) => b.total - a.total);

  // Top 10 + otros
  const TOP_N = 10;
  const topItems = combinedArray.slice(0, TOP_N);
  const others = combinedArray.slice(TOP_N);
  if (others.length > 0) {
    const sumOthers = others.reduce(
      (acc, curr) => {
        acc.day += curr.day;
        acc.night += curr.night;
        acc.total += curr.total;
        return acc;
      },
      { level: "OTRAS", day: 0, night: 0, total: 0 }
    );
    topItems.push(sumOthers);
  }

  // Formato para Nivo
  const data = topItems.map((item) => ({
    level: item.level,
    Diurno: item.day,
    Nocturno: item.night,
  }));

  // Definir colores fijos para las barras
  const barColors = {
    Diurno: colors.primary,
    Nocturno: colors.secondary,
  };

  const theme = {
    background: colors.cardBg,
    axis: {
      domain: {
        line: {
          stroke: colors.border,
          strokeWidth: 1,
        },
      },
      ticks: {
        line: {
          stroke: colors.border,
          strokeWidth: 1,
        },
        text: {
          fill: colors.text,
          fontSize: 12,
        },
      },
      legend: {
        text: {
          fill: colors.text,
          fontSize: 13,
          fontWeight: 500,
        },
      },
    },
    legends: {
      text: {
        fill: colors.text,
        fontSize: 12,
      },
    },
    tooltip: {
      container: {
        background: colors.cardBg,
        color: colors.text,
        fontSize: 12,
        borderRadius: 8,
        boxShadow: colors.shadow,
        border: `1px solid ${colors.border}`,
      },
    },
    grid: {
      line: {
        stroke: colors.border,
        strokeWidth: 1,
        strokeDasharray: "4 4",
      },
    },
    labels: {
      text: {
        fill: colors.cardBg,
        fontSize: 11,
        fontWeight: 500,
      },
    },
  };

  return (
    <div style={{ height: "400px", background: colors.cardBg }}>
      <ResponsiveBar
        data={data}
        keys={["Diurno", "Nocturno"]}
        indexBy="level"
        margin={{ top: 50, right: 130, bottom: 80, left: 60 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={({ id }) => barColors[id]}
        theme={theme}
        borderRadius={4}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 45,
          legend: groupLevel.toUpperCase(),
          legendPosition: "middle",
          legendOffset: 70,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Vehículos",
          legendPosition: "middle",
          legendOffset: -40,
        }}
        enableGridY={true}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={colors.cardBg}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                  itemBackground: colors.hover,
                  itemTextColor: colors.primary,
                },
              },
            ],
          },
        ]}
        motionConfig={{
          mass: 1,
          tension: 170,
          friction: 26,
          clamp: false,
          precision: 0.01,
          velocity: 0,
        }}
        role="application"
        ariaLabel="Gráfico de barras de vehículos por ubicación"
        barAriaLabel={function (e) {
          return (
            e.id + ": " + e.formattedValue + " vehículos en " + e.indexValue
          );
        }}
        onClick={(bar) => {
          if (onItemSelect) onItemSelect(bar.data.level);
        }}
      />
    </div>
  );
};

export default VehicleLocationsBarChart;
